import { render, staticRenderFns } from "./Bill.vue?vue&type=template&id=5bba5c8c&scoped=true"
import script from "./Bill.vue?vue&type=script&lang=js"
export * from "./Bill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bba5c8c",
  null
  
)

export default component.exports